import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { useTranslation, Trans } from 'react-i18next'
import {
  SmallText,
  TextLink,
} from 'ggx-componentlibrary/design/typography/typography.styles'

import { formatCurrency } from '../../service/i18n/format-currency.service'
import {
  OrderChargeMessage,
  SufficientInsufficientBalanceText,
  StyledTextLink,
  WalletBalance,
  ErrorMessage,
} from './wallet.component.styles'

const Wallet = ({
  openModal,
  orderQuotation,
  prepaidBalance,
  showBalance,
  input,
  meta,
  hideDisclaimers,
  showMessage,
  disabled,
}) => {
  const [t] = useTranslation()
  const sufficientBalance =
    prepaidBalance > 0 && prepaidBalance >= orderQuotation

  useEffect(() => {
    input.onChange(sufficientBalance)
  }, [sufficientBalance])

  const insufficientBalanceText = (
    <SufficientInsufficientBalanceText>
      {t('newOrder.tab.summary.paymentMethod.balance.insufficient.label')}
      <StyledTextLink onClick={openModal}>
        {t('newOrder.tab.summary.paymentMethod.balance.insufficient.topup')}
      </StyledTextLink>
    </SufficientInsufficientBalanceText>
  )

  const sufficientBalanceText = (
    <SufficientInsufficientBalanceText>
      <StyledTextLink onClick={openModal}>
        {t('newOrder.tab.summary.paymentMethod.balance.sufficient.topup')}
      </StyledTextLink>
      {t('newOrder.tab.summary.paymentMethod.balance.sufficient.label')}
    </SufficientInsufficientBalanceText>
  )

  const walletBalance = `${t(
    'orderdetail.paymentMethod.wallet'
  )} (${formatCurrency({ amount: prepaidBalance })})`

  const { touched, error } = meta
  const errorMessage = touched ? error : null

  return (
    <React.Fragment>
      {showBalance && <WalletBalance>{walletBalance}</WalletBalance>}
      {disabled && showMessage && sufficientBalance && sufficientBalanceText}
      {disabled && showMessage && !sufficientBalance && insufficientBalanceText}
      {!disabled && sufficientBalance && sufficientBalanceText}
      {!disabled && !sufficientBalance && insufficientBalanceText}

      {errorMessage && <ErrorMessage>{errorMessage}</ErrorMessage>}

      {!hideDisclaimers && (
        <OrderChargeMessage>
          {t('orderDetails.info.orderMessage')}
        </OrderChargeMessage>
      )}

      {!hideDisclaimers && (
        <SmallText typographyStyles="mt-m mb-none">
          <Trans
            i18nKey="common__text_terms&conditions"
            components={
              <TextLink
                href={t('common__link_terms&conditions')}
                target="_blank"
              />
            }
          />
        </SmallText>
      )}
    </React.Fragment>
  )
}

Wallet.propTypes = {
  input: PropTypes.shape({
    value: PropTypes.string,
    onChange: PropTypes.func,
  }),
  orderQuotation: PropTypes.number,
  prepaidBalance: PropTypes.number,
  showBalance: PropTypes.bool,
  openModal: PropTypes.func,
  meta: PropTypes.shape({
    touched: PropTypes.bool.isRequired,
    error: PropTypes.string.isRequired,
  }),
  hideDisclaimers: PropTypes.bool,
  showMessage: PropTypes.bool,
  disabled: PropTypes.bool,
}

Wallet.defaultProps = {
  showBalance: false,
  openModal: () => {},
}

export { Wallet }
